module.exports = __webpack_public_path__ + "fonts/b1261953/proxima_nova_reg-latin-a.woff";